import React from 'react'
import { SKILLS } from '../raw_cv.js'

const Skills = (props) => {
  return (
    <section id="skills">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="skills__heading_wrapper">
              <h3 className="skills__desc">Skills</h3>
            </div>
            <div className="clearfix"/>

            { SKILLS.map( skill => (
              <dl key={skill.name} className="dl-horizontal">
                <dt>{skill.name}</dt>
                <dd>{skill.list}</dd>
              </dl>
            ))}
          </div> {/* col-md-8 */}
        </div> {/* row end */}
      </div> {/* container */}
    </section>
  )
}

export default Skills
